<template>
  <div class="column-list">
    <div v-title :data-title="title"></div>
    <van-pull-refresh
      v-if="columnList.length || loading"
      v-model="refreshing"
      @refresh="onRefresh"
      success-text="刷新成功">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"

      >
      <ColumnCard
        v-for="item in columnList"
        :key="item.id"
        :rowData="item"
        type='list'
      >
      </ColumnCard>
      </van-list>
    </van-pull-refresh>
    <van-empty
      v-else
      description="暂无数据" />
  </div>
</template>
<script>
import api from '../../api';
import { mapState } from 'vuex';
import ColumnCard from '../../components/columnCard.vue';
export default {
  components: {
    ColumnCard,
  },
  data() {
    return {
      pageParams: {
        current: 1,
        pageSize: 10
      },
      columnList: [],
      loading: false,
      finished: false,
      refreshing: false,
      title: '专栏'
    }
  },
  computed: {
    ...mapState(['userInfo']),
  },
  created() {
    this.fetchColumnList();
  },
  methods: {
    fetchColumnList() {
      this.loading = true;
      this.title = !this.$route.query?.id || this.$route.query?.id === this.userInfo?.id ? '我的专栏' : `${this.$route.query.userName || 'Ta'}的专栏`
      api.getMyColumns({
        ...this.pageParams,
        userId: this.$route.query?.id || this.userInfo?.id,
        orderType: 3,
      }).then((res) => {
        this.loading = false
        const {code, data, totalCount} = res;
        if (this.refreshing) {
          this.refreshing = false
        }
        if (code === 200) {
          if (this.pageParams.current > 1) {
            this.columnList = this.columnList.concat(data)
          } else {
            this.columnList = data
          }
          if (this.columnList.length >= totalCount) {
            this.finished = true
          }
        }
      })
    },
    onLoad() {
      this.pageParams.current++
      this.fetchColumnList()
    },
    onRefresh() {
      this.finished = false
      this.pageParams.current = 1 
      this.fetchColumnList()
    },
  }
}
</script>
<style lang="less" scoped>
.column-list {
  // padding:10px;
}
/deep/ .van-list {
  padding-bottom:50px;
  // display: grid;
  // grid-template-columns: repeat(2, auto);
  // grid-column-gap: 12px;
} 
</style>